var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousyearpaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1386_681)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "url(#paint0_linear_1386_681)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0285 23H9.89757C9.1797 22.7178 9.00315 22.4547 9.00315 21.6655C9.00315 18.3594 9.00315 15.0547 9.00315 11.7486C9.00315 11.1914 8.9944 10.6343 9.00607 10.0771C9.01628 9.60562 9.24828 9.2657 9.67871 9.08687C9.8217 9.02775 9.98803 9.01297 10.1442 9.00706C10.4754 8.99524 10.808 9.0041 11.1553 9.0041C11.1553 8.84597 11.148 8.70556 11.1568 8.56664C11.167 8.41146 11.1728 8.25332 11.2151 8.10553C11.3917 7.47593 11.9855 7.02516 12.6552 7.00743C13.0361 6.99856 13.4154 7.00447 13.7962 7.00447C16.0111 7.00447 18.2275 7.01334 20.4424 7.00004C21.3353 6.99413 22.113 7.65624 22.0911 8.65975C22.059 10.1007 22.0824 11.5432 22.0824 12.9856C22.0824 15.136 22.0824 17.2849 22.0824 19.4353C22.0824 19.8816 21.935 20.26 21.614 20.5659C21.3164 20.8482 20.9589 20.9886 20.5533 20.9989C20.3505 21.0048 20.1462 20.9989 19.9273 20.9989C19.9273 21.3315 19.9332 21.6433 19.9259 21.9537C19.9142 22.4089 19.6253 22.7946 19.2007 22.9394C19.1423 22.9587 19.0854 22.9793 19.0271 22.9986L19.0285 23ZM9.99095 15.9902C9.99095 17.9219 9.99095 19.8535 9.99095 21.7852C9.99095 21.9281 10.0629 21.9995 10.2069 21.9995C13.0448 21.9995 15.8827 21.9995 18.7207 21.9995C18.8685 21.9995 18.9429 21.9251 18.9439 21.7763C18.9439 17.9234 18.9439 14.0704 18.9439 10.2175C18.9439 10.0746 18.8719 10.0032 18.728 10.0032C15.89 10.0032 13.0521 10.0032 10.2142 10.0032C10.0654 10.0032 9.99095 10.0776 9.99095 10.2263C9.99095 12.1476 9.99095 14.0689 9.99095 15.9902ZM19.9302 20.0013C20.1155 20.0013 20.2833 20.0013 20.4511 20.0013C20.508 20.0013 20.5649 20.0013 20.6204 19.9925C20.9253 19.9407 21.0946 19.7353 21.0946 19.4205C21.0946 18.7392 21.0946 18.0564 21.0946 17.3751C21.0946 14.4443 21.0946 11.5136 21.096 8.58142C21.096 8.35382 21.0173 8.17794 20.8174 8.08631C20.705 8.03459 20.5708 8.00946 20.4468 8.00798C17.8919 8.00355 15.337 8.00503 12.7822 8.00503C12.7355 8.00503 12.6888 8.00503 12.6436 8.00798C12.3897 8.03606 12.1694 8.21341 12.1504 8.42919C12.1343 8.61393 12.1475 8.80163 12.1475 9.0041H12.3357C14.4849 9.0041 16.6327 9.0041 18.7819 9.0041C19.0314 9.0041 19.2634 9.0514 19.4663 9.19919C19.7975 9.44009 19.9302 9.77262 19.9302 10.182C19.9259 13.3832 19.9273 16.5859 19.9273 19.787V20.0013H19.9302Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 12.7536C15.3387 12.7536 16.115 12.7521 16.8912 12.7536C17.1276 12.7536 17.307 12.8955 17.3727 13.1172C17.4325 13.3211 17.3581 13.5487 17.1728 13.661C17.0882 13.7113 16.9817 13.7482 16.8839 13.7482C15.3314 13.7541 13.779 13.7527 12.2265 13.7512C11.9362 13.7512 11.7188 13.5339 11.7173 13.2561C11.7158 12.9708 11.9332 12.7536 12.2338 12.7536C13.01 12.7521 13.7863 12.7536 14.5625 12.7536Z",
    fill: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5713 14.752C15.3271 14.752 16.0829 14.752 16.8387 14.752C17.167 14.752 17.3917 14.9544 17.3932 15.2485C17.3946 15.5441 17.1699 15.751 16.8445 15.751C15.3183 15.751 13.7907 15.751 12.2645 15.751C11.9406 15.751 11.7144 15.5412 11.7173 15.2471C11.7202 14.9515 11.942 14.752 12.2732 14.752C13.0392 14.752 13.8053 14.752 14.5713 14.752Z",
    fill: "#252525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.564 16.7516C15.3402 16.7516 16.1164 16.7502 16.8927 16.7516C17.129 16.7516 17.3085 16.8935 17.3742 17.1167C17.434 17.3206 17.3596 17.5482 17.1728 17.6606C17.0882 17.7108 16.9817 17.7463 16.8839 17.7478C15.3314 17.7537 13.779 17.7522 12.2265 17.7507C11.9376 17.7507 11.7202 17.532 11.7173 17.2556C11.7158 16.9704 11.9332 16.7546 12.2338 16.7531C13.01 16.7516 13.7863 16.7531 14.5625 16.7531L14.564 16.7516Z",
    fill: "#252525"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1386_681",
    x: -30,
    y: -30,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1386_681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1386_681",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1386_681",
    x1: 2,
    y1: 2,
    x2: 45.0352,
    y2: 56.5959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousyearpaper);
export default __webpack_public_path__ + "static/media/Previousyearpaper.15fde302c8582f396c7abe622a4ff2a3.svg";
export { ForwardRef as ReactComponent };